// extracted by mini-css-extract-plugin
export var active = "hs-link-dr-module--active--ae503";
export var copytext = "hs-link-dr-module--copytext--50cde";
export var darkBackground = "hs-link-dr-module--dark-background--00acf";
export var hsLink = "hs-link-dr-module--hs-link--324b9";
export var standard = "hs-link-dr-module--standard--21420";